<template>
    <div>
     <div >
      <nav class="w-52 bg-white fixed left-0 top-0  min-h-screen  shadow-md">
      <div class="pt-14 pl-3 pb-4 bg-black">
         <h3 class="text-white">Tally<span class="text-green-500">Clinic</span></h3>
         <hr>
      </div>
      <!-- <h6 class=" mt-1 pl-4 text-gray-400 font-bold">Menu</h6> -->
    <ul class="flex flex-col items-center mt-2 ">

   
      <li class="h-9 w-full">
         <jet-nav-link   :href="'/integrate?is_license_valid='+is_valid_license+'&is_electron='+is_electron+'&license_from_database='+license_no" class="bg-link-hover w-full  flex items-center p-0 pl-4 text-gray-400 relative active">
           <i class="far fa-envelope mr-3"></i>
           <span class="link-label">Integrate</span>
        </jet-nav-link>
      </li>
      <!--  -->
      <li class="h-9 w-full">
        <a href="#" class="hover:bg-link-hover transition-colors duration-500 w-full  flex items-center p-0 pl-4 text-gray-400  relative">
          <i class="fas fa-signal mr-3"></i>
        <span class="link-label">Manage</span>
        </a>
      </li>
      <!--  -->
      <li class="h-9 w-full">
        <a href="#" class="hover:bg-link-hover transition-colors duration-500 w-full flex items-center p-0 pl-4 text-gray-400  relative">
        <i class="far fa-hospital mr-3"></i>
          <span class="link-label">Print</span>
        </a>
      </li>
      <!--  -->
      <li class="h-9 w-full">
        <a href="#" class="hover:bg-link-hover transition-colors duration-500 w-full flex items-center p-0 pl-4 text-gray-400  relative">
        <i class="fas fa-chart-line mr-3"></i>
        <span class="link-label">Report</span>
        </a>
      </li>
      <!--  -->
      <li class="h-9 w-full">
        <a href="#" class="hover:bg-link-hover transition-colors duration-500 w-full  flex items-center p-0  pl-4 text-gray-400  relative">
        <i class="fas fa-users mr-3"></i>
        <span class="link-label">Analyse</span>
        </a>
      </li>
      <!--  -->
      <li class="h-9 w-full">
        <a href="#" class="hover:bg-link-hover transition-colors duration-500 w-full flex items-center p-0 pl-4 text-gray-400  relative">
        <i class="far fa-comments mr-3"></i>
      <span class="link-label">Sync</span>
        </a>
      </li>
      <!--  -->
      <li class="h-9 w-full">
        <a href="#" class="hover:bg-link-hover transition-colors duration-500 w-full flex items-center p-0 pl-4 text-gray-400  relative">
        <i class="fas fa-cogs mr-3"></i>
          <span class="link-label">Tally-on-Cloud</span>
        </a>
      </li>
      <!--  -->
      <li class="h-9 w-full">
        <a href="#" class="hover:bg-link-hover transition-colors duration-500 w-full flex items-center p-0 pl-4 text-gray-400  relative">
        <i class="fas fa-cogs mr-3"></i>
          <span class="link-label">Add-Ons</span>
        </a>
      </li>
      <!--  -->
      <li class="h-9 w-full">
        <a href="#" class="hover:bg-link-hover transition-colors duration-500 w-full flex items-center p-0 pl-4 text-gray-400  relative">
        <i class="fas fa-cogs mr-3"></i>
          <span class="link-label">Modules</span>
        </a>
      </li>
      <!--  -->
      <li class="h-9 w-full">
        <a href="#" class="hover:bg-link-hover transition-colors duration-500 w-full flex items-center p-0 pl-4 text-gray-400  relative">
        <i class="fas fa-cogs mr-3"></i>
          <span class="link-label">Services</span>
        </a>
      </li>
      <!--  -->
      <li class="h-9 w-full">
        <a href="#" class="hover:bg-link-hover transition-colors duration-500 w-full flex items-center p-0 pl-4 text-gray-400  relative">
        <i class="fas fa-cogs mr-3"></i>
          <span class="link-label">Trainings</span>
        </a>
      </li>
      <!--  -->
      <li class="h-9 w-full">
        <a href="#" class="hover:bg-link-hover transition-colors duration-500 w-full flex items-center p-0 pl-4 text-gray-400  relative">
        <i class="fas fa-cogs mr-3"></i>
          <span class="link-label">Webinars</span>
        </a>
      </li>
      <!--  -->
    </ul>
            <h6 class="text-gray-400  ml-4 font-bold">Account</h6>
              <ul>
                <!--  -->
                <li class="h-6 w-full">
              <a href="#" class="hover:bg-link-hover transition-colors duration-500 w-full flex items-center p-0 pl-4 text-gray-400  relative">
              <i class="fas fa-cogs mr-3"></i>
                <span  id="refresh" class="link-label">Help & Support</span>
              </a>
            </li>
            <!--  -->
            <li class="h-6 w-full">
              <!-- <a href="" class="hover:bg-link-hover transition-colors duration-500 w-full flex items-center p-0 pl-4 text-gray-400  relative">
              <i class="fas fa-cogs mr-3"></i>
                <span class="link-label">Settings</span>
              </a> -->
                <jet-nav-link   :href="'/configurations'" class="hover:bg-link-hover transition-colors duration-500 w-full flex items-center p-0 pl-4 text-gray-400  relative">
                  <i class="fas fa-cogs mr-3"></i>
                  <h6 class="link-label">Settings</h6>
                </jet-nav-link>
            </li>
              <!--  -->
             <li class="h-6 w-full">
              <a href="#" class="hover:bg-link-hover transition-colors duration-500 w-full flex items-center p-0 pl-4 text-gray-400  relative">
              <i class="fas fa-cogs mr-3"></i>
                <span class="link-label">Log Out</span>
              </a>
            </li>
            <!--  -->
              </ul>
      </nav>
     </div>
     
      <!-- header -->
       <header class="shadow-sm max-w-8xl">
          <!-- <a href="#">Dashboard</a> -->
          <h2 class="font-bold mt-6 ml-2">Clients</h2>
        <!--   <button>click this</button> -->
        <ul class="nav-list mt-6">
          <!-- <li><a href="#">Home</a></li>
          <li><a href="#">Contact</a></li> -->
          <form>
            <!-- <i class="fas fa-search"></i> -->
            <input type="search" placeholder="Search...">
          </form>
        </ul>
      </header>

     <!-- NavBar -->
      <nav-bar >
              <slot name="headerNav" v-if="$slots.headerNav"></slot>
      </nav-bar>
  

      <div class="main-content">
           <slot></slot>
      </div>
    </div>
</template>
<script>
import JetNavLink from '@/Jetstream/NavLink.vue';
import NavBar from '../../Layouts/TallyClinicTopNavbar.vue';
export default {
  components:{
    JetNavLink,
    NavBar,
   
  },
   mounted(){

  $('li').on('click',function(){
    var a_links = $(this).find('a');
    $('a').removeClass('active');
    a_links.addClass('active');
  })
},

}
</script>

<style scoped>
body {
  min-height: 100vh;
  background-color: #dbe3ff;
  padding: 0px;
}
html{
  font-family:Rubik !important;
}
a.active {
  color:#10b981;
  font-weight: 300;
   /* background: #abffe3; */
}
 a.active::after {
  content: "";
  height: 100%;
  position: absolute;
  left: 205px;
  top: 0;
  width: 4px;
  background-color: #10b981;
}
a:hover{
  /* background-color: #10b981; */
  color: #10b981;
  text-decoration: none;
}
nav{
  transition:all .2s;
  /* border: 2px solid rgb(233, 233, 233); */
}

nav.expanded .link-label {
  display: none;
}
nav.expanded {
  width: 66px;
}
nav.expanded ul li{
  align-items: center;
  justify-content: center;
}
nav.expanded ul li a{
  align-items: center;
  justify-content: center;
}
nav.expanded ul li a svg{
 margin: 0;
}

/* header page */
header{
  /* width: 100%; */
  padding:13px;
  display:flex;
  justify-content:space-between;
  background:white;
  /* border: 1px solid gray; */
 	margin-left: 210px;
}
.nav-list{
  display:flex;
  flex-flow : row-reverse wrap;
  justify-content: space-around;
  align-items: center;
}
.nav-list li{
  display:inline-block;
  padding:10px;
  margin: 4px;
  width:auto;
  border-radius: 10px;
}
.nav-list a{
  color: rgb(150, 145, 145);
}
</style>